"use client";

import { useTranslations } from "next-intl";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "framer-motion";
import { useEffect } from "react";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

export default function HeroSection() {
  const t = useTranslations("user");
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin);
  }, []);

  const handleClick = () => {
    gsap.to(window, {
      duration: 1,
      ease: "power3.out",
      scrollTo: { y: "#next-section", autoKill: true },
    });
  };
  return (
    <section className="relative -mt-20 flex h-screen flex-col items-center justify-center bg-[url('/images/backgrounds/bg-user-hero.png')] bg-cover bg-center">
      <Reveal
        delay={0.1}
        duration={0.8}
        direction="left"
        withBlur={true}
        blurAmount={8}
      >
        <h1 className="text-center text-[56px]/[64px] font-normal text-black max-md:text-[48px]/[56px] max-sm:text-[32px]/[40px]">
          {t("your-gateway-to-ai-sovereignty")}
        </h1>
      </Reveal>
      <Reveal
        delay={0.5}
        duration={0.8}
        direction="left"
        withBlur={true}
        blurAmount={8}
      >
        <p className="mt-5 text-center text-lg leading-[26px] tracking-[-1px] text-black opacity-[0.8] max-md:text-base max-sm:text-sm">
          {t(
            "earn-passively-protect-your-privacy-and-join-the-global-ai-sovereignty-movement",
          )}
        </p>
      </Reveal>
      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <button
          onClick={handleClick}
          className="mt-[66px] rounded-[12px] bg-[#0066FF] px-12 py-[14px] text-base font-medium text-white max-lg:mt-12"
        >
          {t("discover")}
        </button>
      </motion.div>
      <div className="absolute bottom-0 h-[200px] w-full bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
